import script from "./BaseTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTab.vue?vue&type=script&setup=true&lang=js"

import "./BaseTab.vue?vue&type=style&index=0&id=642e5d44&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642e5d44"]])

export default __exports__